<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="PARÁMETROS DE LEY" key="1">
          <g-master name="parametros_de_ley"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="80%"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Año')" v-bind="fiOptions">
                    <a-select v-decorator="['year', { rules: [
                            { required: true, message: 'Valor requerido' },
                           ], initialValue: yearToday }]" style="width: 100%">
                      <a-select-option v-for="year_ in years" :key="year_">
                        {{ year_ }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Salario mínimo')">
                    <a-input-number
                      style="width: 100%"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      v-decorator="['salmin', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Subtra')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['subtra', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Mínimo integral')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['minintegral', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Uvt')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['uvt', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tope excento')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['tope_excento', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Sal. mín. alimentación')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['sal_max_alim', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tope de vivienda')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['tope_vivienda', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tope solidaridad')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['tope_solid', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tope ing. año anterior')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['tope_ing_anoant', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tope renta excento')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['tope_renta_excento', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tope cer salud')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['tope_cer_salud', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tope cer dependiente')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['tope_cer_dependiente', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tope iman año anterior')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['tope_iman_anoant', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tope seg. social')">
                    <a-input-number
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      style="width: 100%"
                      v-decorator="['tope_ss', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('País')"
                              :formItemConfig="fiOptions"
                              :decorator="['country', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="country">
                  </g-dropdown>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Histórico" key="1">
              <co-legal-hist v-if="id_parametro_ley" :id="id_parametro_ley"></co-legal-hist>
              <span v-else>Seleccione un parámetro de ley para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        years: [],
        yearToday: parseInt(moment().format('YYYY')),
        country: {
          h_lookup_type: 'COUNTRY_PROCESS',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          endpoint: 'co_legal',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Salario mínimo', dataIndex: 'salmin', sorter: true},
              {title: 'Subtra', dataIndex: 'subtra', sorter: true},
              {title: 'Mínimo integral', dataIndex: 'minintegral', sorter: true},
              {title: 'Uvt', dataIndex: 'uvt', sorter: true},
              {title: 'Tope excento', dataIndex: 'tope_excento', sorter: true},
              {title: 'Salario máximo de alimentación', dataIndex: 'sal_max_alim', sorter: true},
              {title: 'Tope de vivienda', dataIndex: 'tope_vivienda', sorter: true},
              {title: 'Tope de solidaridad', dataIndex: 'tope_solid', sorter: true},
              {title: 'Tope ingreso año anterior', dataIndex: 'tope_ing_anoant', sorter: true},
              {title: 'Tope renta excento', dataIndex: 'tope_renta_excento', sorter: true},
              {title: 'Tope cer salud', dataIndex: 'tope_cer_salud', sorter: true},
              {title: 'Tope cer dependiente', dataIndex: 'tope_cer_dependiente', sorter: true},
              {title: 'Tope seguridad social', dataIndex: 'tope_ss', sorter: true},
              {title: 'País', dataIndex: 'view_attr', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'country'},
            {name: 'minintegral'},
            {name: 'sal_max_alim'},
            {name: 'salmin'},
            {name: 'subtra'},
            {name: 'tope_cer_dependiente'},
            {name: 'tope_cer_salud'},
            {name: 'tope_excento'},
            {name: 'tope_iman_anoant'},
            {name: 'tope_ing_anoant'},
            {name: 'tope_renta_excento'},
            {name: 'tope_solid'},
            {name: 'tope_ss'},
            {name: 'tope_vivienda'},
            {name: 'uvt'},
            {name: 'year'}
          ]
        }
      }
    },
    mounted () {
      this.yearsSelect()
    },
    methods: {
      yearsSelect () {
        for (let i = this.yearToday - 30; i <= (this.yearToday + 30); i++) {
          this.years.push(i)
        }
      }
    },
    computed: {
      id_parametro_ley () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/CoLegal/CoLegal.vue